import { useEffect, useState } from "react"
import { Box } from "@mui/material"

import { useAppContext } from "../../components/AppContextProvider"
import { useEntitlex } from "../../hooks/entitlex/useEntitlexData"

import { Error } from "./components/Error"
import { EntitlexGuard } from "./components/EntitlexGuard"
import { EntitySelector } from "./components/EntitySelector"
import { EntityDetails } from "./components/EntityDetails"

const EntitlexData = () => {
  const { user } = useAppContext()
  const [{ application, list }, setState] = useState({ application: null, list: null })

  const handleApplicationChange = (value) => {
    setState((prev) => ({
      ...prev,
      application: value.name || value,
      list: null
    }))
  }

  const handleListChange = (value) =>
    setState((prev) => ({
      ...prev,
      list: value
    }))

  const data = useEntitlex(user?.email, application, list?.key)

  useEffect(() => {
    const application = (data.applications.value || [{}])[0].name
    if (application) {
      setState((prev) => ({
        ...prev,
        application
      }))
    }
  }, [data.applications?.value])

  useEffect(() => {
    const list = (data.permissions.value?.lists || [])[0]
    if (list) {
      setState((prev) => ({
        ...prev,
        list
      }))
    }
  }, [data.permissions.value?.lists])

  return (
    <EntitlexGuard
      isLoading={data.entitlex.isAvailabilityLoading}
      isAvailable={data.entitlex.isAvailable}
      hasAdminAccess={data.entitlex.hasAdminAccess}
    >
      <Box sx={{ position: "relative" }}>
        <Error error={data.error} resetError={data.resetError} />
        <EntitySelector
          freeSolo
          caption="Application"
          value={application}
          options={data.applications.value}
          onChange={handleApplicationChange}
          isLoading={data.applications.loading}
        />
        <EntityDetails
          header="Permissions"
          data={data.permissions.value?.resources}
          isLoading={data.permissions.loading}
        />
        <EntitySelector
          caption="List"
          value={list}
          options={data.permissions.value?.lists}
          onChange={handleListChange}
        />
        <EntityDetails header="List Content" data={data.list.value} isLoading={data.list.loading} />
      </Box>
    </EntitlexGuard>
  )
}

export default EntitlexData
